import { useEffect } from "react";
import { decodeUserInfo } from "../../utils/user";
import { decodeJwtPayload } from "../../utils/jwt";

export function getTokenExpiryMs(jwt?: string | null): number {
  const payload = decodeJwtPayload<{ exp?: number }>(jwt);
  return payload?.exp ? payload.exp * 1000 : 0;
}

export function useTokenExpiry(token: string | null, logout: () => void) {
  useEffect(() => {
    if (!token) return;
    const expMs = getTokenExpiryMs(token);
    if (!expMs) return;
    if (expMs <= Date.now()) {
      logout();
      return;
    }
    const id = window.setTimeout(logout, expMs - Date.now());
    return () => window.clearTimeout(id);
  }, [token, logout]);
}

export function isStaffRole(token: string | null): boolean {
  const { role } = decodeUserInfo(token);
  return role?.trim().toUpperCase() === "STAFF";
}

export function isManagerRole(token: string | null): boolean {
  const { role } = decodeUserInfo(token);
  return role?.trim().toUpperCase() === "MANAGER";
}

export function isTrainerRole(token: string | null): boolean {
  const { role } = decodeUserInfo(token);
  return role?.trim().toUpperCase() === "TRAINER";
}

export function isSuperAdminRole(token: string | null): boolean {
  const { role } = decodeUserInfo(token);
  return role?.trim().toUpperCase() === "SUPERADMIN";
}
